var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',[_c('CCard',[_c('CCardHeader',[_vm._v(" Delegates ")]),_c('CCardBody',[_c('CDataTable',{attrs:{"items":_vm.items,"fields":_vm.fields,"items-per-page":5,"pagination":""}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }